"use client"

import Text from "@/components/common/Typography/Text"
import { TypeTourItinerary } from "@/lib/redux/features/tour/types"
import { faChevronDown } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Col, Collapse, Image, Row } from "antd"
import { FC, useState } from "react"
import { breakdownChars } from "../TourContentConditions"
import { useTranslation } from "react-i18next"

type TourProgramItemProps = {
  program: TypeTourItinerary
}

const TourProgramItem: FC<TourProgramItemProps> = ({ program }) => {
  const [open, setOpen] = useState<boolean>(false)
  const { t } = useTranslation()

  return (
    <Collapse
      className="tour-detail__programs--item"
      expandIcon={() => null}
      expandIconPosition='end'
      activeKey={open ? "1" : undefined}
      onChange={() => setOpen(p => !p)}
      items={[
        {
          key: "1",
          styles: {
            header: {
              paddingBlock: 0,
              paddingLeft: !!program.images.length ? 0 : undefined
            },
          },
          label: (
            <Row gutter={10} wrap={false} justify='space-between' align='middle'>
              <Col>
                <Row gutter={10} wrap={false}>
                  {!!program.images.length && (<Col>
                    <Image
                      styles={{
                        root: { height: '100%', minHeight: "9rem" }
                      }}
                      preview={false}
                      style={{ width: '15rem', height: '100%', minHeight: "9rem", objectFit: 'cover', borderTopLeftRadius: 8, borderBottomLeftRadius: open ? 0 : 8 }}
                      src={program.images[0]}
                    />
                  </Col>)}
                  <Col>
                    <Row style={{ marginTop: '0.5rem' }}>
                      <Text className="tour-detail__program-day" strong>
                        {t("common.day")} {program.day}
                      </Text>
                    </Row>
                    <Row>
                      <Text strong>
                        {program.title}
                      </Text>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Text
                  type="secondary"
                  className={`tour-detail__program-chevron${open ? " tour-detail__program-chevron--open" : ""}`}
                >
                  <FontAwesomeIcon icon={faChevronDown} />
                </Text>
              </Col>
            </Row>
          ),
          children: (
            <>
              <Row className="tour-detail__programs--item-content">
                <Col span={24} dangerouslySetInnerHTML={{ __html: breakdownChars.reduce((str, char, idx) => str.replace(char, str[0] === char ? "– " : "").replaceAll(char, "<br><br> –"), program.description) }} />
              </Row>
            </>
          )
        }
      ]}
    />
  )
}

export default TourProgramItem